export default "__VITE_ASSET__BFqq0Fro__"